/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://gis.clark.wa.gov/portal/jsapi/jsapi4/esri/copyright.txt for details.
*/
import{create as e}from"../../../../core/libs/gl-matrix-2/factories/mat3f32.js";import{TiledDisplayObject as r}from"./TiledDisplayObject.js";class t extends r{_createTransforms(){return{displayViewScreenMat3:e(),tileMat3:e()}}}export{t as RenderableTile};
